import React, { FC } from "react";
import { IconButtonProps, SvgIcon, SvgIconProps } from "@mui/material";

import { StyledMuiIconButton } from "./styled";

export interface IPanelButton extends IconButtonProps {
  svgProps?: SvgIconProps;
}

export const PanelButton: FC<IPanelButton> = props => {
  const { children, svgProps, onClick, ...rest } = props;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation();
    onClick && onClick(event);
  };

  return (
    <StyledMuiIconButton size="small" color="inherit" {...rest} onClick={handleClick}>
      <SvgIcon {...svgProps}>{children}</SvgIcon>
    </StyledMuiIconButton>
  );
};
